import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

class WarningModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.show}
          toggle={this.props.onCloseClick}
          centered={true}
        >
          <ModalBody>
            <Row>
              <Col lg={18}>
                <div>
                  <h5>
                    {" "}
                    <i
                      className="bx bx-info-circle"
                      style={{
                        marginRight: "3px",
                        marginTop: "-4px",
                        fontSize: "1.5em",
                        color: "yellow",
                      }}
                    />
                    {this.props.t("warningMessage")}
                  </h5>
                </div>
                <div className="modal-body">
                  <p>
                    {!this.props.warningMessage
                      ? this.props.t("defaultMessage")
                      : this.props.warningMessage}
                  </p>
                </div>
              </Col>
            </Row>
            <ModalHeader style={{ marginBottom: "10px" }}></ModalHeader>
            <Row>
              <Col lg={12}>
                <div style={{ textAlign: "right" }}>
                
                  <button
                    type="button"
                    className="btn btn-secondary me-1"
                    onClick={this.props.onCloseClick}
                  >
                    {this.props.t("ok")}
                  </button>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}
 
WarningModal.propTypes = {
  onCloseClick: PropTypes.func,
  warningMessage: PropTypes.any,
  show: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(WarningModal);
